import { ResponsavelAquisicao } from '../../modules/types/Aquisicao';
import httpClient from '../httpClient';
export async function getAllResponsaveisPorEntidade(tab: string, id: number) {
  try {
    const response = await httpClient.get(
      `/api/responsavelaquisicao/porentidade`,
      {
        params: {
          tab,
          id,
        },
      },
    );
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function handleCreateResponsavel(
  form: ResponsavelAquisicao,
  tab: string,
) {
  try {
    return await httpClient.post(`/api/responsavelaquisicao?tab=${tab}`, form);
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateResponsavel(form: ResponsavelAquisicao) {
  try {
    const response = await httpClient.patch(
      `/api/responsavelaquisicao/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteResponsavel(id: string) {
  try {
    return await httpClient.delete(`/api/responsavelaquisicao/${id}`);
  } catch (error) {
    throw error;
  }
}
